import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const HotelBuildingIcon = createIcon({
  displayName: 'HotelBuildingIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <line
        x1="1.99999"
        y1="21"
        x2="21.99999"
        y2="21"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M21,21V4a1,1,0,0,0-1-1H10A1,1,0,0,0,9,4L9,21"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="12"
        y1="7"
        x2="17.99999"
        y2="7"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="12"
        y1="10"
        x2="17.99999"
        y2="10"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="12"
        y1="13"
        x2="17.99999"
        y2="13"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M3,21V8A1,1,0,0,1,4,7H9"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="17"
        y1="21"
        x2="17"
        y2="17"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="13"
        y1="17"
        x2="13"
        y2="21"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="18"
        y1="17"
        x2="12"
        y2="17"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const HotelBuilding: FC<IconProps> = (props) => {
  return <CustomIcon as={HotelBuildingIcon} {...props} />
}

export default memo(HotelBuilding)
